import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, BoxContain } from './styles';

const FooterInformation = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <BoxContain data-panel='panel-estadisticas-footer-TabletMobile'>
        {t('panel.estadisticas.footer.tabletMobile')}
      </BoxContain>
    </Container>
  );
};

export default FooterInformation;
